import { render, staticRenderFns } from "./ActionPage.vue?vue&type=template&id=073875e6&scoped=true&"
import script from "./ActionPage.vue?vue&type=script&lang=js&"
export * from "./ActionPage.vue?vue&type=script&lang=js&"
import style0 from "./ActionPage.vue?vue&type=style&index=0&id=073875e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073875e6",
  null
  
)

export default component.exports